import { RouterModule } from '@angular/router';
import { AppointmentsComponent } from './appointments.component';

export const UsersRoutesModule = RouterModule.forChild([
    // { path: '', component: UsersComponent }
]);
